import * as actionType from '../actionTypes';

const initialState = {
    loggedIn: false,
    user: '',
    otpSent: false,
    otpValues: '',
    envType:localStorage.getItem('envType')?localStorage.getItem('envType'):'DEV'
}
const authentication = (state = initialState, action) => {
    // debugger;
    switch (action.type) {
        case actionType.AUTH_SUCCESS:
            window.envType=action.envType;
            localStorage.setItem('envType',action.envType)
            return {
                otpSent: false,
                loggedIn: true,
                user: action.user,
                envType:action.envType
            };
        case actionType.OTP_SUCCESS:
            return {
                otpSent: true,
                otpValues: action.user
            };
        case actionType.AUTH_FAIL:
            return {
                loggedIn: false,
                user: action.user
            };
        case actionType.AUTH_LOGOUT:
            return {};
        default:
            return state
    }
}
export default authentication;